import { apiFetchJson } from '../http/apiFetch';

export interface ImpersonateTargetUser {
  id: string;
  email: string;
  name: string;
}

export interface ImpersonateResult {
  sessionId: string;
  token: string;
  expiresAt: string;
  targetUser: ImpersonateTargetUser;
}

function asString(value: unknown, fallback = ''): string {
  return value === null || value === undefined ? fallback : String(value);
}

function normalizeImpersonateResult(row: unknown): ImpersonateResult {
  const r = (row ?? {}) as Record<string, unknown>;
  const targetRaw = (r.targetUser ?? r.TargetUser ?? {}) as Record<string, unknown>;
  return {
    sessionId: asString(r.sessionId ?? r.SessionId),
    token: asString(r.token ?? r.Token),
    expiresAt: asString(r.expiresAt ?? r.ExpiresAt),
    targetUser: {
      id: asString(targetRaw.id ?? targetRaw.Id),
      email: asString(targetRaw.email ?? targetRaw.Email),
      name: asString(targetRaw.name ?? targetRaw.Name),
    },
  };
}

/** Starts an admin impersonation session for a merchant or 3PL user. */
export async function startImpersonation(
  targetUserId: string,
  getAccessToken: () => Promise<string | undefined>
): Promise<ImpersonateResult> {
  const result = await apiFetchJson<unknown>('/api/admin/impersonate', {
    method: 'POST',
    getAccessToken,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ targetUserId }),
  });
  return normalizeImpersonateResult(result);
}
